import * as React from "react"
import ContentPageLayout from "../../components/ContentPageLayout"
import Seo from "../../components/seo"
// import { StaticImage } from "gatsby-plugin-image";
// import { getLegalPages } from "../../api/content";
import ReactMarkdown from "react-markdown"
import TextField from "@material-ui/core/TextField"
import SCButton from "../../components/buttons/SCButton"
import { checkCode, applyCode } from "../../api/content"
import firebase from "firebase"
import { firebaseInit } from "../../config"
import { navigate } from "gatsby-link"
import { StaticImage } from "gatsby-plugin-image"

const IndexPage = ({ location }) => {
  const getInitialCode = () => {
    if (typeof location !== "undefined" && location.search) {
      const params = new URLSearchParams(location.search)
      return params.get("code") || ""
    }
    return ""
  }

  const [code, setCode] = React.useState(getInitialCode)
  const [appliedCode, setAppliedCode] = React.useState(false)
  const [error, setError] = React.useState("")
  const [showLoginMessage, setShowLoginMessage] = React.useState(false)
  const [secondsLeft, setSecondsLeft] = React.useState(5)

  React.useEffect(() => {
    firebaseInit(firebase)
  }, [])

  React.useEffect(() => {
    if (!showLoginMessage) return

    if (secondsLeft <= 0) {
      navigate(`/login?code=${code}`)
      return
    }

    const timerId = setTimeout(() => {
      setSecondsLeft(prev => prev - 1)
    }, 1000)

    return () => clearTimeout(timerId)
  }, [showLoginMessage, secondsLeft])

  const resetError = () => {
    setTimeout(() => setError(""), 10000)
  }

  const sendCode = async () => {
    if (!code.trim()) {
      setError("Ingresa tu código válido")
      resetError()
      return
    }

    try {
      const response = await checkCode(code)

      const isErrorCode =
        response.errorCode === 1004 ||
        response.errorCode === 9999 ||
        response.errorCode === 1009

      if (response.estatus === "Error" && !isErrorCode) {
        setError(response.message || "Ocurrió un error al validar el código")
        resetError()
        return
      }

      // En caso de que checkCode retorne errorCode 1004/1009/9999 o estatus distinto a "Error"
      await handleApplyOrRedirect()
    } catch (err) {
      const isErrorCode =
        err.errorCode === 1004 || err.errorCode === 9999 || err.errorCode === 1009

      if (isErrorCode) {
        await handleApplyOrRedirect()
      } else {
        setError(err.message || "Ocurrió un error al validar el código")
        resetError()
      }
    }
  }

  const handleApplyOrRedirect = async () => {
    const user = firebase.auth().currentUser

    if (user) {
      try {
        const token = await user.getIdToken(true)
        try {
          await applyCode(token, code)
          setAppliedCode(true)
        } catch (applyErr) {
          const isRedirectError =
            applyErr.errorCode === 1004 ||
            applyErr.errorCode === 9999 ||
            applyErr.errorCode === 1009

          if (isRedirectError) {
            navigate(`/settings/redeem-code?code=${code}&authorization=${token}`)
          } else {
            setError(applyErr.message || "Ocurrió un error al aplicar el código")
            resetError()
          }
        }
      } catch {
        setError("No se pudo obtener el token de usuario")
        resetError()
      }
    } else {
      localStorage.setItem("promoCode", code)
      setShowLoginMessage(true)
      setSecondsLeft(5)
    }
  }

  return (
    <ContentPageLayout>
      <Seo title="Código Promocional" />
      <div className="flex w-full justify-center">
        {!appliedCode && !showLoginMessage ? (
          <div className="flex text-center h-screen flex-col w-80 justify-center items-center">
            <h1 className="text-3xl md:mb-7 md:text-3xl">Ingresa tu código</h1>
            <hr className="w-full" />
            <p className="font-bold">Términos y condiciones de promoción</p>
            <TextField
              className="w-64"
              style={{ marginTop: "5px", marginBottom: "5px" }}
              type={"text"}
              onChange={({ target }) => setCode(target.value)}
              value={code}
              placeholder="Ingresa aquí tu código"
              error={!!error}
              helperText={error}
            />
            <div className="w-64 mt-8">
              <SCButton
                style={{
                  marginTop: "8px",
                  backgroundColor: error ? "red" : "initial",
                }}
                onClick={sendCode}
              >
                Validar y aplicar
              </SCButton>
            </div>
          </div>
        ) : showLoginMessage ? (
          <div className="flex text-center flex-col w-80 justify-center items-center h-screen">
            <p className="text-green-500 font-bold mb-0">
              ¡Código válido! Debes iniciar sesión para aplicarlo.
              <span className="block text-gray-400 font-normal mt-1">
                Redirigiendo a la página de inicio de sesión en {secondsLeft}
                segundos...
              </span>
            </p>
          </div>
        ) : (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-80 text-center">
              <h2 className="text-xl font-bold mb-4">¡Código aplicado!</h2>
              <p className="text-lg mb-4">
                Descarga nuestra app para disfrutar al máximo:
              </p>
              <div className="flex flex-col space-y-2 mb-6">
                {/* Aquí usamos StaticImage con ruta literal */}
                <a
                  href="https://apps.apple.com/mx/app/shift/id1599569136"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-auto w-52"
                >
                  <StaticImage
                    src="../../images/appstore-badge_ea.webp"
                    alt="Disponible en App Store"
                    className="mx-auto"
                    placeholder="blurred"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.sportcity.sportcity"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-auto w-44"
                >
                  <StaticImage
                    src="../../images/disponible_android.png"
                    alt="Disponible en Google Play"
                    className="mx-auto"
                    placeholder="blurred"
                  />
                </a>
              </div>
              <SCButton onClick={() => navigate(`/`)}>Ir a contenido</SCButton>
            </div>
          </div>
        )}
      </div>
    </ContentPageLayout>
  );
};

export default IndexPage
